export const isCustomerModePavillon = (isViewModeCustomerMode) => isViewModeCustomerMode;
